module.exports = __webpack_public_path__ + "static/media/vasu_goel.f6bdfc9d.jpg";